import { Col, Descriptions, Table } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';
import { DataTable, TextAreaField } from 'components';
import { basicInfoPlan, basicInfoSchema } from 'utils/beneficiaryColumns';
import { isEmpty } from 'lodash';
import { columns } from 'pages/mainForms/mainForm/components/basicInfo/components/subTab3/columns';
import { getFullDateTimeWithSeconds, printInfo } from 'utils/helpers';
import { currencyFormatter, percentageFormatter } from 'utils';

const BasicInfo = () => {

  const apptrackDetails = useSelector(state=>state.appTrack.apptrackDetails);
  const parseFlag = apptrackDetails?.variablesIndexed?.parseFlag;
  const jsonVariables = apptrackDetails?.variablesIndexed?.dapanesEpendysis ? JSON?.parse(apptrackDetails?.variablesIndexed?.dapanesEpendysis) : {};
  // console.log("apptrackDetails:",JSON.parse(apptrackDetails.variablesIndexed.dapanesEpendysis));
  // console.log("apptrackDetails:",apptrackDetails.localTaskVariables);
  const excelData = useSelector(state => state.appTrack?.apptrackDetails?.variablesIndexed?.dapanesEpendysis
  )
  const localTaskVariables = apptrackDetails?.localTaskVariables
  const variablesIndexed = isEmpty(localTaskVariables) || apptrackDetails.activeTaskName !== 'task.name.submit_application' ? apptrackDetails?.variablesIndexed : localTaskVariables;

  const columnsInvestmentTotalAmountTable = [
    {
      title : 'Χρηματοδοτικό Σχήμα Επένδυσης',
      dataIndex : 'title',
      key : 'title',
      align: 'left',
      width: 126,
    },
    {
      title: '% Συνεισφοράς',
      dataIndex : 'percentage',
      key: 'percentage',
      align: 'center',
      width: 126,
    },
    {
      title: 'Ποσό (€)',
      dataIndex : 'SumTotalExpense',
      key: 'SumTotalExpense',
      align: 'right',
      width: 126,
    },
  ]
  
   const testSelectedDataTable = [
    {
      title:"Ιδία Συμμετοχή/Ενισχύσεις", //totalEstimate
      percentage:percentageFormatter(variablesIndexed?.totalEstimatePercentage*100),
      SumTotalExpense : currencyFormatter(variablesIndexed?.totalEstimate)
    },
    {
      title:"Εμπορικό Δάνειο", //commercial loan
      percentage:percentageFormatter(variablesIndexed?.commercialLoanPercentage*100),
      SumTotalExpense : currencyFormatter(variablesIndexed?.commercialLoan)
    },
    {
      title:"Δάνειο ΤΑΑ", //loan
      percentage:percentageFormatter(variablesIndexed?.loanPercentage),
      SumTotalExpense : currencyFormatter(variablesIndexed?.loan)
    },
    {
      title:"Σύνολο", //totalbudget
      percentage:"100,00%",
      SumTotalExpense : currencyFormatter(variablesIndexed?.totalEstimate + variablesIndexed?.commercialLoan + variablesIndexed?.loan)
    },
      
  ] 

  return (
    <div className=''>
      <p className="mt-6 mr-0 color-blue-3 text-bold font-size-24">
        Επενδυτικό Σχέδιο
      </p>
      <div style={{display:"flex"}}>
        <Descriptions
          // title="Βασικά Στοιχεία Επιχείρησης"
          bordered
          className="large-titles-purple-responsive investment-plan-details-table"
          style={{width:"47%", marginRight:"6%"}}
          column={1}
        >
          <Descriptions.Item label="Ημερομηνία & Ώρα Υποβολής">
            {getFullDateTimeWithSeconds(variablesIndexed?.submissionDate)}
          </Descriptions.Item>
          <Descriptions.Item label="Αρ. ΓΕΜΗ">
            {printInfo(variablesIndexed?.abiGcrCode)}
          </Descriptions.Item>
          <Descriptions.Item label="Α.Φ.Μ. Εταιρείας">
            {printInfo(variablesIndexed?.legalVat)}
          </Descriptions.Item>
          <Descriptions.Item label="Επωνυμία Εταιρείας ">
            {printInfo(variablesIndexed?.companyName)}
          </Descriptions.Item>
          <Descriptions.Item label="Τηλέφωνο Επικοινωνίας">
            {printInfo(variablesIndexed?.legalPhoneMobile)}
          </Descriptions.Item>
          <Descriptions.Item label="Email Επικοινωνίας">
            {printInfo(variablesIndexed?.legalEmail)}
          </Descriptions.Item>
          <Descriptions.Item label="Τίτλος Επενδυτικού Σχεδίου">
            {printInfo(jsonVariables?.ependutikoSxedio?.titlos)}
          </Descriptions.Item>
          <Descriptions.Item label="Κ.Α.Δ. Επενδυτικού Σχεδίου">
            {printInfo(jsonVariables?.ependutikoSxedio?.kwdikosKad)}
          </Descriptions.Item>
          <Descriptions.Item label="Τόπος Εκτέλεσης Επενδυτικού Σχεδίου">
            {printInfo(jsonVariables?.toposEkteleshs?.topos?.toUpperCase())}
          </Descriptions.Item>
          <Descriptions.Item label="Ημερομηνία Έναρξης">
            {printInfo(jsonVariables?.ependutikoSxedio?.enarksh)}
          </Descriptions.Item>
          <Descriptions.Item label="Ημερομηνία Ολοκλήρωσης">
          {printInfo(jsonVariables?.ependutikoSxedio?.oloklhrwsh)}
          </Descriptions.Item>
          <Descriptions.Item label="Πιστωτικό Ίδρυμα">
            {printInfo(variablesIndexed?.bnkBank)}
          </Descriptions.Item>
        </Descriptions>
        <div style={{width:"47%"}}>
          <div className='basicInfoSubtitleWrapper'>
            <span className='basicInfoSubtitle'>Σύντομη Περιγραφή</span>
          </div>
          <TextAreaField className="basicInfoTextArea" disabled={true} value={jsonVariables?.ependutikoSxedio?.perigrafi}></TextAreaField>
        </div>
      </div>
      <p className="mt-6 mr-0 color-blue-3 text-bold font-size-24">
      Στοιχεία Πραγματικών Δικαιούχων
            </p>
      <Col span={24}>
        <div>
          <Table
            // scroll={{ x: true }}
            id="basicInfo-application-results-table"
            className="results-table"
            dataSource={variablesIndexed?.carrierBeneficiaries}
            rowKey="id"
            columns={columns}
            // pagination={{
            //   showSizeChanger: false,
            //   showTitle: false,
            // }}
            pagination={false}
          />
        </div>
      </Col>
      {parseFlag == false && 
      // {

      <>
      <p className="mr-0 color-blue-3 text-bold font-size-24" style={{'marginTop' : '-4.5rem'}}>
        Χρηματοδοτικό Σχήμα Επένδυσης
      </p>
        <Col span={24}>
          <div>
            <DataTable
              scroll={{ x: true }}
              id="basicInfo-application-results-table"
              className={`${!isEmpty(excelData)?'table-with-totals-purple':'table-with-totals-purple table-no-data'}`}
              columns={columnsInvestmentTotalAmountTable}
              dataSource={testSelectedDataTable}
              rowKey="id"
              // pagination={{
              //   showSizeChanger: false,
              //   showTitle: false,
              // }}
              pagination={false}
            />
          </div>
        </Col>
        </>
      }
    </div>
    
  );
};

export default BasicInfo;